// Returns a promise that resolves after a specified number of milliseconds.
export default (ms) =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
